import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { useUnauthenticatedAPI } from "@/api";
import { useAccessToken } from "@/Auth/useAccessToken";

export function useResetPassword() {
  const { setAccessToken } = useAccessToken();
  const api = useUnauthenticatedAPI();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (args: { token: string; newPassword: string }) => {
      return api.postResetPassword({
        ResetPasswordRequest: {
          newPassword: args.newPassword,
          token: args.token,
        },
      });
    },
    onSuccess: ({ token: { token } }) => {
      setAccessToken(token);
      navigate("/");
    },
  });
}
